import { Objective1 } from '@mm-shared/types/Objective1';
import { MilestoneMap1 } from '@mm-shared/types/MilestoneMap1';

/**
 * Checks if an objective is a parent in a given milestone map
 */
export function isParentInMap(objectiveUuid: string, milestoneMap: MilestoneMap1): boolean {
  return milestoneMap?.parentObjectiveUuids?.includes(objectiveUuid) ?? false;
}

/**
 * Gets all parent objectives for a given objective
 */
export function getParentObjectives(
  objective: Objective1,
  allObjectives: Objective1[],
): Objective1[] {
  return allObjectives.filter((obj) => objective.parentIds.includes(obj.uuid));
}

/**
 * Gets all child objectives for a given objective
 */
export function getChildObjectives(
  objective: Objective1,
  allObjectives: Objective1[],
): Objective1[] {
  return allObjectives.filter((obj) => objective.childIds.includes(obj.uuid));
}

/**
 * Gets objectives in the order specified by the milestone map
 */
export function getOrderedObjectives(
  milestoneMap: MilestoneMap1,
  allObjectives: Objective1[],
): Objective1[] {
  return milestoneMap.objectiveUuids
    .map((uuid) => allObjectives.find((obj) => obj.uuid === uuid))
    .filter((obj): obj is Objective1 => obj !== undefined);
}

/**
 * Gets the most recent status code for an objective
 */
export function getLatestStatusCode(objective: Objective1): string {
  const latestStatus = objective.statuses
    .sort((a, b) => {
      const dateA = a.lastUpdatedDate ? new Date(a.lastUpdatedDate).getTime() : 0;
      const dateB = b.lastUpdatedDate ? new Date(b.lastUpdatedDate).getTime() : 0;
      return dateB - dateA;
    })
    .at(0);

  return latestStatus?.statusCode || '';
}
